/**
 * Сюжет книги (01-SPEC.md §3.9): результат работы генератора, разобранный
 * в структуру разворотов.
 */
import { z } from 'zod';
/** Максимальная длина свободных пожеланий, из которых генератор строит сюжет. */
export const STORY_MAIN_IDEA_MAX_LENGTH = 10_000;
export const StoryDraftSourceSchema = z.enum(['manual', 'ai']);
export const StoryDraftSpreadSchema = z.object({
    index: z.number().int().min(0),
    textRu: z.string(),
    promptEn: z.string(),
    animationEn: z.string().default(''),
    characterIds: z.array(z.string().min(1)).default([]),
    thingIds: z.array(z.string().min(1)).default([]),
    locationId: z.string().min(1).nullable().default(null),
});
/** `StoryDraft.parsed` — массив разворотов (01-SPEC.md §3.9). */
export const StoryDraftParsedSchema = z.array(StoryDraftSpreadSchema);
/** Полный структурированный ответ генератора сюжета. */
export const StoryDraftOutputSchema = z.object({
    titleRu: z.string().trim().min(1).max(200),
    spreads: StoryDraftParsedSchema,
});
//# sourceMappingURL=story.js.map